import axios from 'axios';
import { buildApiUrl } from '../config/api';

export const CategoriaService = {
    getCategorias: async (token) => {
        try {
            const response = await axios.get(buildApiUrl('/api/ajustes/categorias'), {
                headers: { Authorization: `Bearer ${token}` },
            });

            return response.data.categorias || [];
        } catch (error) {
            console.error('Error en CategoriaService.fetchCategorias:', error);
            throw error;
        }
    },
    guardarCategoria: async ({ token, formData, editingItem }) => {
        try {
            if (editingItem) {
                await axios.put(
                    buildApiUrl(`/api/ajustes/categorias/${editingItem.id}`),
                    formData,
                    {
                        headers: { Authorization: `Bearer ${token}` },
                    }
                );
            } else {
                await axios.post(buildApiUrl('/api/ajustes/categorias'), formData, {
                    headers: { Authorization: `Bearer ${token}` },
                });
            }
        } catch (error) {
            console.error('Error en CategoriaService.guardarCategoria:', error);
            throw error;
        }
    },
};
